import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/**
 * Card de seção com cabeçalho (título, descrição, ações) e rodapé opcional.
 * Se `collapsible`, o cabeçalho alterna `open` via `onToggle`.
 */
export default function SectionCard({
    title,
    description,
    status,
    actions,
    footer,
    collapsible = false,
    open = true,
    onToggle,
    children,
    contentSx,
    sx,
}) {
    const hasBody = Boolean(children);

    return (
        <Card sx={{ ...sx }}>
            <Box
                onClick={collapsible ? onToggle : undefined}
                role={collapsible ? 'button' : undefined}
                aria-expanded={collapsible ? open : undefined}
                tabIndex={collapsible ? 0 : undefined}
                onKeyDown={collapsible ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onToggle?.(); } } : undefined}
                sx={{
                    px: 2.5,
                    py: 2,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    cursor: collapsible ? 'pointer' : 'default',
                    borderBottom: hasBody && open ? '1px solid' : 'none',
                    borderColor: 'divider',
                    '&:hover': collapsible ? { bgcolor: '#FCFCFD' } : undefined,
                }}
            >
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="h5" component="h2">
                        {title}
                    </Typography>
                    {description && (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                            {description}
                        </Typography>
                    )}
                </Box>
                {status}
                {actions && <Box sx={{ display: 'flex', gap: 1 }} onClick={(e) => e.stopPropagation()}>{actions}</Box>}
                {collapsible && (
                    <ExpandMoreIcon
                        sx={{
                            color: 'text.secondary',
                            transition: 'transform 150ms',
                            transform: open ? 'rotate(180deg)' : 'none',
                        }}
                    />
                )}
            </Box>

            {hasBody && (
                <Collapse in={open} timeout={collapsible ? 'auto' : 0} unmountOnExit={false}>
                    <Box sx={{ p: 2.5, ...contentSx }}>{children}</Box>
                    {footer && (
                        <Box
                            sx={{
                                px: 2.5,
                                py: 1.5,
                                borderTop: '1px solid',
                                borderColor: 'divider',
                                bgcolor: '#FCFCFD',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: 1,
                            }}
                        >
                            {footer}
                        </Box>
                    )}
                </Collapse>
            )}
        </Card>
    );
}
